import React from 'react'
import FullCalendar from '@fullcalendar/react'
import timeGridPlugin from '@fullcalendar/timegrid'
import CalendarLocale from '@fullcalendar/core/locales/pt-br'

export default props => (
  <FullCalendar
    expandRows
    handleWindowResize
    displayEventTime={false}
    locale={CalendarLocale}
    plugins={[timeGridPlugin]}
    initialView="timeGridWeek"
    slotMinTime="08:00:00"
    slotMaxTime="19:00:00"
    businessHours={{
      daysOfWeek: [1, 2, 3, 4, 5],
      startTime: '08:00',
      endTime: '19:00',
    }}
    headerToolbar={{
      left: 'prev,next today',
      center: 'title',
      right: 'timeGridWeek,timeGridDay',
    }}
    {...props}
  />
)
